/* Shapeez Sizing Calculator */          
(function() {
  var braEl, bodyEl, resultEl, wizardToggle

  var cur_bra_sz ={};
  cur_bra_sz['Group1']={'32A':'7.5','32B':'8','32C':'8.5','32D':'9'};
  cur_bra_sz['Group2']={'34AA':'7.5','34A':'8','34B':'8.5','34C':'9','34D':'9.5','34DD':'10','34DDD':'10.5','34E':'11'};
  cur_bra_sz['Group3']={'36AA':'8','36A':'8.5','36B':'9','36C':'9.5','36D':'10','36DD':'10.5','36DDD':'11','36E':'11.5','36F':'12'};
  cur_bra_sz['Group4']={'38AA':'8.5','38A':'9','38B':'9.5','38C':'10','38D':'10.5','38DD':'11','38DDD':'11.5','38E':'12','38F':'13'};
  cur_bra_sz['Group5']={'40AA':'8.5','40A':'9','40B':'9.5','40C':'10','40D':'10.5','40DD':'11','40DDD':'11.5','40E':'12','40F':'13'};
  cur_bra_sz['Group6']={'42A':'9.5','42B':'10','42C':'10.5','42D':'11','42DD':'11.5','42DDD':'12','42E':'13'};
  cur_bra_sz['Group7']={'44A':'10','44B':'10.5','44C':'11','44D':'11.5','44DD':'12','44DDD':'13'};
  cur_bra_sz['Group8']={'46B':'10.5','46C':'11','46D':'11.5','46DD':'12','46DDD':'13'};

  var bodysize={};
  bodysize['30-32']={'7.5':'XS-A','8':'XS-B','8.5':'XS-C','9':'XS-D'};
  bodysize['33-34']={'7.5':'Small-AA','8':'Small-A','8.5':'Small-B','9':'Small-C','9.5':'Small-D','10':'Small-DD','10.5':'Small-DDD','11':'Small-E'};
  bodysize['35-37']={'8':'Medium-AA','8.5':'Medium-A','9':'Medium-B','9.5':'Medium-C','10':'Medium-D','10.5':'Medium-DD','11':'Medium-DDD','11.5':'Medium-E','12':'Medium-F'};
  bodysize['38-40']={'8.5':'Large-AA','9':'Large-A','9.5':'Large-B','10':'Large-C','10.5':'Large-D','11':'Large-DD','11.5':'Large-DDD','12':'Large-E','13':'Large-F'};
  bodysize['41-43']={'9.5':'XL-A','10':'XL-B','10.5':'XL-C','11':'XL-D','11.5':'XL-DD','12':'XL-DDD','13':'XL-E'};
  bodysize['44-46']={'10.5':'1X-B','11':'1X-C','11.5':'1X-D','12':'1X-DD','13':'1X-DDD'};

  
  wizardToggle = document.getElementById('sizing-toggle')    
  braEl = document.getElementById('bra')
  bodyEl = document.getElementById('body')
  resultEl = document.getElementById('result')
  
  $(document).ready(function(){    
    
    $.each(cur_bra_sz, function(i, item) {
      $.each(item, function(i, itm) {
        $(braEl).append("<option value='"+itm+"'>"+i+"</option>");
      })
    })

    $.each(bodysize, function(i, item) {
      $(bodyEl).append("<option value='"+i+"'>"+i+"</option>");
    })
  })
  
  $(".sizing-wizard-section select").on("change",function(){
    var current_bra_size, body_size, result
    current_bra_size= braEl.value
    body_size = bodyEl.value
    result = '';
    
    if(current_bra_size != '' && body_size != '') {
      result = bodysize[body_size][current_bra_size];

      resultEl.classList.remove('your-shapeez-size-prompt')
      
      if (typeof(result) != 'undefined') {
        resultEl.classList.remove('your-shapeez-size-prompt')
        resultEl.innerText = result;
      } else {
        resultEl.classList.add('your-shapeez-size-prompt')
        resultEl.innerText = " not available - We couldn't find a corresponding Shapeez size. Please call our fit specialist at 877-360-8426.";
      }
    }
  });
  
  if (wizardToggle !== null) {
    wizardToggle.addEventListener('click', function(){
      $(".sizing-wizard-section").slideToggle( 600 );
    })
  }
})()

/* Accessibility Code for "shapeez.com" */
window.interdeal = {
  "sitekey": "18a522f6aba7ac7092ca9fb74c4dfd7c",
  "Position": "right",
  "Menulang": "EN",
  "domains": {
    "js": "https://cdn.equalweb.com/",
    "acc": "https://access.equalweb.com/"
  },
  "btnStyle": {
    "vPosition": [
      "50%",
      null
    ],
    "scale": [
      "0.8",
      "0.8"
    ],
    "color": {
      "main": "#6e7577",
      "second": "#ffffff"
    },
    "icon": {
      "type": 7,
      "shape": "semicircle"
    }
  }
};
(function(doc, head, body){
  var coreCall             = doc.createElement('script');
  coreCall.src             = interdeal.domains.js + 'core/4.6.3/accessibility.js';
  coreCall.defer           = true;
  coreCall.integrity       = 'sha512-+5lbZsIsOqyfEswqMIHyOrR4jrrBUQ0aVv0KYYoZ6/jTkKsTIqAHwkHgFEoRDM3NbjZ0lOxR0qSslbA3NIXrfw==';
  coreCall.crossOrigin     = 'anonymous';
  coreCall.setAttribute('data-cfasync', true );
  body? body.appendChild(coreCall) : head.appendChild(coreCall);
})(document, document.head, document.body);